import Arrow from 'Elements/Button/Arrow/Arrow';
import styled, { css } from 'styled-components';
import NextImage from 'next/image';

export const PromoPoint = styled.div`
    ${({ theme }) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 1.5rem 0 1.5rem 0;
        position: relative;
        border-radius: 0.5rem;
        background: ${theme.colors.primaryContrast.hex};
        height: 100%;
        width: 100%;
        margin-bottom: 1.8rem;
    `}
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        font-size: 1.5rem;
        color: ${theme.colors.secondaryContrast.hex};
        margin: 0;
        padding: 0 4rem 0 4rem;
        text-align: center;
    `}
`;

export const SixImagesList = styled.ul`
    ${({ theme }) => css`
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-evenly;
        position: relative;
        width: 100%;
        height: auto;
        gap: 1rem;
        list-style: none;
        padding: 0;

        @media ${theme.breakpoints.medium.media} {
            display: none;
        }

        @media ${theme.breakpoints.large.media} {
            display: flex;
            flex-wrap: nowrap;
            justify-content: space-between;
        }
    `}
`;

export const FourImagesList = styled.ul`
    ${({ theme }) => css`
        display: none;
        flex-direction: row;
        justify-content: space-between;
        position: relative;
        width: 100%;
        height: auto;
        gap: 1rem;
        list-style: none;
        padding: 0;

        @media ${theme.breakpoints.medium.media} {
            display: flex;
        }

        @media ${theme.breakpoints.large.media} {
            display: none;
        }
    `}
`;

export const ImagesListItem = styled.li`
    ${({ theme }) => css`
        height: 9rem;
        width: 100%;
        position: relative;
        max-width: 10rem;

        @media ${theme.breakpoints.medium.media} {
            max-width: none;
        }

        @media ${theme.breakpoints.large.media} {
            height: 11.25rem;
        }
    `}
`;

export const ItemImage = styled(NextImage)`
    border-radius: 0.5rem;
`;

export const Text = styled.p`
    ${({ theme }) => css`
        color: ${theme.colors.secondaryContrast.hex};
        padding: 0 4rem 0 4rem;
        text-align: center;
        margin-top: 0;
        margin-bottom: 0.5rem;
    `}
`;

export const ArrowButton = styled(Arrow)`
    max-width: 80%;
    position: absolute;
    bottom: 0;
    transform: translateY(50%);
    white-space: normal;
    text-align: center;
`;
